/**
 * O NÚMERO QUE DIZ QUAL CAMADA ESTÁ ATIVA — `T1.7`.
 *
 * Ele: *"não dá pra saber qual layer está ativa"*. Medido no editor da vitrine em 27/09, com um
 * balão selecionado: a palavra "camada" não aparecia **uma vez** no `innerText` do editor inteiro.
 * Os dois botões de pilha existiam e funcionavam; o que faltava era a tela dizer onde o item está.
 *
 * ── POR QUE UM NÚMERO NO MENU, E NÃO UM PAINEL ──────────────────────────────────────────────
 *
 * O menu do item aparece **junto do item**, e é onde a pergunta nasce: a criança acabou de clicar
 * no desenho e quer saber por que ele está atrás do outro. Um painel à direita responde a mesma
 * pergunta a três centímetros de distância e custa uma tela nova.
 *
 * O elemento **não é botão** de propósito: ele não faz nada: os dois botões ao lado é que agem.
 * Um controle que parece clicável e não é ensina que a tela está quebrada.
 *
 * E ele só aparece com **mais de um** desenho na página: com um só, "1 de 1" é ruído, e a pergunta
 * "qual está ativa" não existe.
 */
import { RenderElProps } from "../classes/draggable-item.class";
import { explicacaoDaPilha, fraseCurtaDaPilha } from "../classes/onde-na-pilha";
import "./posicao-na-pilha.scss";

export default function PosicaoNaPilha(props: RenderElProps) {
  const lugar = props.comic.lugarNaPilha(props.item);
  if (lugar.total < 2) return <></>;

  const explicacao = explicacaoDaPilha(lugar);
  return (
    <span
      className="posicao-na-pilha"
      title={explicacao}
      // `img` com rótulo: é conteúdo que se lê, e não um grupo por onde se navega. O leitor de tela
      // anuncia a explicação inteira, que é onde cabe a direção ("a de cima aparece na frente").
      role="img"
      aria-label={explicacao}
    >
      {fraseCurtaDaPilha(lugar)}
    </span>
  );
}
